import { useEffect, useMemo, useState } from "react";
// import { useNavigate } from "react-router";
import {
  Avatar,
  Button,
  Card,
  Input,
  Modal,
  Space,
  Switch,
  Table,
  Tag,
  Tooltip,
  Typography,
  message,
} from "antd";
import { EditOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { postReq } from "../api.js";
import dayjs from "dayjs";

const { Text } = Typography;
const url = process.env.REACT_APP_API_URL;
const User = () => {
  // const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 1,
    pageSize: 10,
    search: "",
  });
  const [candidate, setCandidate] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const toggleUserStatus = async (userId) => {
    try {
      const res = await postReq("user/user_status_change", { userId });
      message.success(res.message || "User status updated successfully");
      fetchData();
    } catch (err) {
      message.error(err.message || "Failed to update user status");
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await postReq("user/list_user", {
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
      });
      if (res.status === 200) {
        setCandidate(res.data.data);
        setTotal(res.data.total);
      } else {
        message.error(res.message || "Error fetching users");
        setCandidate([]);
        setTotal(0);
      }
    } catch (error) {
      message.error(error.message || "Error fetching users");
      setCandidate([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // Debounced search
  useEffect(() => {
    const timeout = setTimeout(() => {
      setPaginationModel((prev) => ({ ...prev, search, page: 1 }));
    }, 600);
    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  const columns = useMemo(
    () => [
      // {
      //   title: "Actions",
      //   key: "actions",
      //   width: 100,
      //   render: (_, row) => (
      //     <Space size={4}>
      //       <Tooltip title="View">
      //         <Button
      //           type="text"
      //           icon={<EyeOutlined />}
      //           onClick={() => navigate("/user-info", { state: row })}
      //         />
      //       </Tooltip>
      //       <Tooltip title="Edit">
      //         <Button
      //           type="text"
      //           icon={<EditOutlined />}
      //           onClick={() => navigate("/user-edit", { state: row })}
      //         />
      //       </Tooltip>
      //     </Space>
      //   ),
      // },
      {
        title: "Name",
        key: "name",
        width: 260,
        render: (_, row) => {
          const { name, profileImage } = row;
          return (
            <Space size={10} align="center">
              <Avatar
                alt={name?.toUpperCase()}
                src={profileImage ? `${url}${profileImage}` : undefined}
                size={28}
              >
                {name?.[0]?.toUpperCase()}
              </Avatar>
              <div>
                <div style={{ fontWeight: 400, fontSize: 13 }}>{`${name}`}</div>
                {/* <Text type="secondary" style={{ fontSize: 11 }}>
                  {empId}
                </Text> */}
              </div>
            </Space>
          );
        },
      },
      {
        title: "Designation",
        key: "role",
        width: 180,
        render: (_, row) => <Text>{row?.role?.name}</Text>,
      },
      {
        title: "Attendance",
        key: "attendance",
        width: 170,
        render: (_, row) => {
          const { attendance } = row;
          if (attendance?.loginTime) {
            return (
              <Text style={{ fontSize: 13 }}>
                {`${dayjs(attendance.loginTime).format("HH:mm A")} / ${attendance.logoutTime ? dayjs(attendance.logoutTime).format("HH:mm A") : "-"}`}
              </Text>
            );
          }
          const status = attendance?.status ?? null;
          return (
            <Tag
              color={
                status
                  ? status === "In Progress"
                    ? "warning"
                    : "blue"
                  : "error"
              }
            >
              {status ?? "Absent"}
            </Tag>
          );
        },
      },
      // {
      //   title: "Active",
      //   key: "active",
      //   width: 100,
      //   render: (_, row) => (
      //     <Switch
      //       disabled={userDetails?._id === row._id}
      //       checked={Boolean(row.isActive)}
      //       onClick={(_, e) => {
      //         e.stopPropagation();
      //         setSelectedUser(row);
      //         setConfirmOpen(true);
      //       }}
      //     />
      //   ),
      // },
    ],
    [userDetails],
  );

  return (
    <>
      <Card bordered={false} styles={{ body: { padding: 24 } }}>
        <Input
          placeholder="Search User Name"
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          allowClear
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: 240, marginBottom: 24 }}
        />

        <Table
          loading={loading}
          dataSource={candidate}
          columns={columns}
          rowKey={(row) => row._id}
          scroll={{ x: "max-content" }}
          rowClassName={(row) => (row.isActive ? "" : "low-stock-row")}
          pagination={{
            current: paginationModel.page,
            pageSize: paginationModel.pageSize,
            total,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20"],
            showTotal: (tot) => `Total ${tot} records`,
            onChange: (page, pageSize) =>
              setPaginationModel((prev) => ({ ...prev, page, pageSize })),
          }}
        />
      </Card>

      <Modal
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        title="Confirm Action"
        footer={[
          <Button key="cancel" onClick={() => setConfirmOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            danger
            type="primary"
            onClick={() => {
              toggleUserStatus(selectedUser._id);
              setConfirmOpen(false);
            }}
          >
            Yes, Confirm
          </Button>,
        ]}
      >
        <Text>
          Are you sure you want to{" "}
          <strong>{selectedUser?.isActive ? "deactivate" : "activate"}</strong>{" "}
          this user?
        </Text>
      </Modal>
    </>
  );
};

export default User;
